import React from "react";
import { Container } from './styles'
import { Spin } from 'antd';

export function Load(){
    return(
        <Container>
            <Spin />
        </Container>
    )
}